export default __webpack_public_path__ + "static/summer_containers68-aa9b1e03531e987c2ba67c4c3a54a44c.webp";